import { render, staticRenderFns } from "./drawLots-prize.vue?vue&type=template&id=223919a7&scoped=true&"
import script from "./drawLots-prize.vue?vue&type=script&lang=js&"
export * from "./drawLots-prize.vue?vue&type=script&lang=js&"
import style0 from "./drawLots-prize.vue?vue&type=style&index=0&id=223919a7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223919a7",
  null
  
)

export default component.exports